import * as React from 'react';

// components
import { BootstrapTable, ButtonGroup } from 'react-bootstrap-table';
import Cell, { CellProps } from './CellNew';

// interfaces
import { GridSchema, TableColum } from '../interfaces';

export interface TableProps {
  disabled: boolean;
  extra: GridSchema['extra'];
  config: {
    insertRow: any;
    deleteRow: any;
    options: {
      insertText: string;
      noDataText: string;
      onRowDoubleClick: (row: any) => void;
      deleteBtn: () => React.JSX.Element;
      btnGroup: (props: any) => React.JSX.Element;
      insertModal: (onModalClose: any) => React.JSX.Element;
    };
  };
  columns: // |
  TableColum[];
  // | {
  //     isKey: boolean;
  //     field: string;
  //     type: string;
  //     description: string;
  //   }
  dataRows: any[];
  ifFieldIsFilledThenBlockRow: string;
  disableViewAndEditButton: boolean;
  onDbClick: (row: any) => void;
  onRowDelete: (row: any) => void;
  containerClass: string;
  errorMessage: any;
  isLastColumnForSum: any;
  withLastColumnForSumData?: Record<string, any>;
  titleRow: any;
  optionsFromUrl?: CellProps['optionsFromUrl'];
}

export const Table = ({
  disabled,
  extra,
  config,
  dataRows,
  ifFieldIsFilledThenBlockRow,
  disableViewAndEditButton,
  onDbClick,
  onRowDelete,
  errorMessage,
  containerClass,
  columns,
  isLastColumnForSum,
  withLastColumnForSumData,
  titleRow,
  optionsFromUrl,
}: TableProps) => {
  const viewTableProps = {
    ...config,
    data: dataRows.map((row) => {
      //Если есть поле которое блокирует всю строку, то блокируем ее, иначе стандартное поведение
      let gridRowDisabled = ifFieldIsFilledThenBlockRow
        ? !!row?.[ifFieldIsFilledThenBlockRow] ?? disabled
        : disabled;

      // @ts-ignore
      return {
        ...row,
        actionField: true,
        extra,
        disabled: gridRowDisabled,
        disableViewAndEditButton,
        onDbClick: onDbClick,
        onRowDelete: onRowDelete,
      };
    }),
    bodyContainerClass: containerClass,
    trClassName: (row, rowIdx) => {
      let searchThisRow;
      if (
        errorMessage &&
        typeof errorMessage === 'object' &&
        errorMessage.length > 0
      ) {
        searchThisRow = errorMessage.find((item) => {
          if (typeof item.index === 'number' && item.index >= 0) {
            return item.index === rowIdx;
          }
          return null;
        });
      }
      return searchThisRow ? 'alert-danger' : '';
    },
  };

  const withLastColumnTableProps = {
    data: withLastColumnForSumData,
    bodyContainerClass: containerClass,
  };

  const renderCell = (column: TableColum, idx: number) => {
    return Cell({
      column,
      idx,
      titleRow,
      optionsFromUrl: !isLastColumnForSum ? optionsFromUrl : undefined,
      last: isLastColumnForSum ? true : undefined,
    });
  };

  return (
    <>
      <BootstrapTable {...viewTableProps}>
        {columns.map(renderCell)}
      </BootstrapTable>

      {/* {this.getLastColumnForSum(this.state.values) ? ( */}
      {isLastColumnForSum ? (
        <BootstrapTable {...withLastColumnTableProps}>
          {columns.map(renderCell)}
        </BootstrapTable>
      ) : null}
    </>
  );
};
